import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  CLASS_TYPES,
  ClassTypeSelect,
  classTypeSelector,
  CONTEST_TYPES,
  resetCreateClassForm,
  setClassType,
  setContestType,
} from 'features/classCreation';
import CreateContestForm from './CreateContestForm';
import CreateLectureForm from './CreateLectureForm';
import CreateNonLiveLectureClassForm from './CreateNonLiveLectureClassForm';
import SectionHeading from 'components/SectionHeading';
import styles from './CreateClassPage.module.scss';

const CREATE_CLASS_FORM_MAP = {
  [CLASS_TYPES.lecture]: CreateLectureForm,
  [CLASS_TYPES.contest]: CreateContestForm,
  [CLASS_TYPES.classWithoutLiveLecture]: CreateNonLiveLectureClassForm,
};

export default function CreateClassPage() {
  const dispatch = useDispatch();
  const classType = useSelector(classTypeSelector);
  const CreateClassFormComponent = CREATE_CLASS_FORM_MAP[classType?.label];

  const handleClassTypeChange = useCallback(
    (option) => {
      batch(() => {
        dispatch(resetCreateClassForm());
        dispatch(setClassType(option));
        if (option.value === CLASS_TYPES.contest) {
          dispatch(setContestType(CONTEST_TYPES.group));
        }
      });
    },
    [dispatch]
  );

  return (
    <div>
      <SectionHeading
        title="CREATE CLASS"
        subtitle="Fill in the following details to create a new class."
      />
      <ClassTypeSelect
        value={classType}
        onChange={handleClassTypeChange}
        className={styles.classTypeSelect}
        placeholder="What do you want to create today?"
      />
      {CreateClassFormComponent && <CreateClassFormComponent />}
    </div>
  );
}
